import { render } from "./0BookingAdd copy.vue?vue&type=template&id=579b0573"
import script from "./0BookingAdd copy.vue?vue&type=script&lang=js"
export * from "./0BookingAdd copy.vue?vue&type=script&lang=js"

import "./0BookingAdd copy.vue?vue&type=style&index=0&id=579b0573&lang=css"

import exportComponent from "E:\\sanket\\rio\\rio_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__